import React, { useEffect, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import OrganisationForm from './OrganisationForm';
import organisationService from '../services/organisationService';
import { TABS } from '../constants';

const EditOrganisation = ({
  dispatchOrganisationGet,
  dispatchUpdateOrganisationPut,
  updateOrganisationFetch,
  organisationFetch,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => dispatchOrganisationGet(id), [dispatchOrganisationGet, id]);

  const initialValues = useMemo(
    () =>
      organisationFetch.value && {
        ...organisationFetch.value,
        countryCode: String(organisationFetch.value.countryCode).toUpperCase(),
      },
    [organisationFetch.value]
  );

  const handleSubmit = useCallback(
    values => {
      dispatchUpdateOrganisationPut(
        id,
        values,
        () => {
          navigate(`/organisations/${id}/${TABS.DETAILS}`);
        },
        t
      );
    },
    [dispatchUpdateOrganisationPut, id, navigate, t]
  );

  return (
    <OrganisationForm
      editMode
      initialValues={initialValues}
      processingForm={!!updateOrganisationFetch.pending}
      onSubmitForm={handleSubmit}
      pageTitle={`Edit organisation ${
        organisationFetch.fulfilled ? organisationFetch.value.organisationName : '...'
      }`}
      loadingContent={!!organisationFetch.pending}
    />
  );
};

EditOrganisation.propTypes = {
  dispatchUpdateOrganisationPut: PropTypes.func.isRequired,
  dispatchOrganisationGet: PropTypes.func.isRequired,
  updateOrganisationFetch: PropTypes.object.isRequired,
  organisationFetch: PropTypes.object.isRequired,
};

export default organisationService(EditOrganisation);
